import { Isometry }    from 'components/Isometry/Isometry'
import { useToggle } from 'hooks/useToggle';
import { useAtom } from 'jotai';
import { getFocus, useGet } from 'state/jotai';
import { _bootstrap } from 'state/store.bootstrap';
import { active_project, vis_desktop_nav, vis_filter } from 'state/store.global';

export const ViewIsometry = () => {
  const { overlayState, toggleOverlay } = useToggle();
  
  const pin         = useGet(active_project).pin
  const projectType = getFocus(_bootstrap, 'type');

  const [, setShowFilter] = useAtom(vis_filter);
  const [, setShowMenu]   = useAtom(vis_desktop_nav);

  return (
    <>
      <div style={{border:'0px solid gray',height: '100%', position:'relative'}} onClick={()=> {
        overlayState.detail && toggleOverlay("detail")
        setShowMenu(false);
      }}>
         <Isometry/>
      </div>
    </>
  )
}